import { FC } from "react";
import { twMerge } from "tailwind-merge";
interface ADPSeparatorProps {
  content: {
    showOnWeb: string;
    componentPostion: string;
    hideInMobile: string;
    isDecorative: string;
    hideOnLogin: string;
    componentTitle: string;
    hideindesktop: string;
    showOnApp: string;
    customClass?: string;
  };
}
const ADPSeparator: FC<ADPSeparatorProps> = ({ content }) => {
  const { hideInMobile, hideindesktop, customClass } = content ?? {};
  const classNames = [];

  if (hideInMobile === "true") {
    classNames.push("hidden md:block");
  } else if (hideindesktop === "true") {
    classNames.push("block md:hidden");
  }
  return (
    <hr
      className={twMerge(`mx-[0%] mb-6 h-[2px] border-none bg-blue-100 ${classNames.join(" ")}`, customClass)}
    ></hr>
  );
};

export default ADPSeparator;
